module.exports = __webpack_public_path__ + "media/images/front/dr_mounai_n-dd24028d4463f3d9b7346509dd166f69.jpg";